// extracted by mini-css-extract-plugin
export default {"footerMenuList":"FooterMenuList_footerMenuList__gAPQq","footerTitle":"FooterMenuList_footerTitle__jD079","bgPulse":"FooterMenuList_bgPulse__hKLwr"};